import { createRouter, createWebHistory } from 'vue-router'
import { getContractorToken, hasUsableAuthToken } from '@/utils/api'
import { isContractorAppPath } from '@/utils/clientPortalHost'
import { clientPortalRoutes } from '@/router/portalRoutes'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: clientPortalRoutes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition
    if (to.hash) return { el: to.hash, behavior: 'smooth' }
    return { top: 0 }
  },
})

router.beforeEach(async (to, _from, next) => {
  const storedToken = getContractorToken()
  if (storedToken && !hasUsableAuthToken(storedToken)) {
    const { useContractorAuthStore } = await import('@/stores/contractorAuthStore')
    useContractorAuthStore().logout()
  }

  const contractorToken = hasUsableAuthToken(getContractorToken()) ? getContractorToken() : null
  const mustChangePassword =
    typeof window !== 'undefined' && localStorage.getItem('contractor_must_change_password') === 'true'
  const isContractorChangePassword = to.name === 'contractor-change-password'
  const onContractorApp = isContractorAppPath(to.path)

  if (!onContractorApp) {
    if (contractorToken && mustChangePassword) {
      next({ name: 'contractor-change-password' })
      return
    }
    next(contractorToken ? { name: 'contractor-dashboard' } : { name: 'contractor-login' })
    return
  }

  if (isContractorChangePassword) {
    if (!contractorToken) {
      next({ name: 'contractor-login' })
      return
    }
    next()
    return
  }

  const requiresContractorAuth = to.matched.some((r) => r.meta.requiresContractorAuth)
  const isContractorLogin = to.name === 'contractor-login'

  if (requiresContractorAuth && !contractorToken) {
    next({ name: 'contractor-login' })
    return
  }

  if (contractorToken && mustChangePassword && (requiresContractorAuth || onContractorApp)) {
    next({ name: 'contractor-change-password' })
    return
  }

  if (requiresContractorAuth && contractorToken) {
    const { useContractorAuthStore } = await import('@/stores/contractorAuthStore')
    const contractorAuth = useContractorAuthStore()
    contractorAuth.restoreFromStorage()
  }

  if (isContractorLogin && contractorToken) {
    if (mustChangePassword) {
      next({ name: 'contractor-change-password' })
      return
    }
    next({ name: 'contractor-dashboard' })
    return
  }

  next()
})

export default router
